import { render, staticRenderFns } from "./RestartControl.vue?vue&type=template&id=2d7d2eb8&"
import script from "./RestartControl.vue?vue&type=script&lang=js&"
export * from "./RestartControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports